import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import {
  DeleteAccountPage,
  DisclaimerPage,
  HomePage,
  PrivacyPage,
  SupportPage,
  TermsPage,
} from './pages';
import './styles.css';

const page = document.body.dataset.page;
const Page = {
  home: HomePage,
  privacy: PrivacyPage,
  terms: TermsPage,
  disclaimer: DisclaimerPage,
  support: SupportPage,
  'delete-account': DeleteAccountPage,
}[page ?? 'home'] ?? HomePage;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Page />
  </StrictMode>,
);
